// extracted by mini-css-extract-plugin
export default {"modal":"NewsModal_modal__tG6-0","modalContent":"NewsModal_modalContent__oWEcA","close":"NewsModal_close__6LaeR","image":"NewsModal_image__jZLJB"};